export default __webpack_public_path__ + "static/media/dashboard_left.bc0640a1.svg";